const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'base',
        'scheduler',
        'scheduler',
    ],

    config: {
        filterDelay: 50,
        projectsControllerComponentClass: 'templates_office_projects_controller',
        projectTermsControllerComponentClass: 'templates_office_projectTerms_controller',
        problemSummaryComponentClass: 'templates_core_projectTerms_problemSummary',
    },

    model: {
        loadedStatusIDs: {}, // stores all statusIDs loaded to determine if a refresh is necessary when heartbeat wants to refresh specific statusIDs.
        filterTimeout: null,
        problemSummaryComponent: null, // problemSummary component to update on hover if necessary
    },

    methods: {
        getResourceFilters: function(storage, resourceFilters, actionKey, fieldCode){
            if(actionKey === 'refreshResources'){
                resourceFilters = resourceFilters || {}

                if(utils.collectionSize(this.model.resourceFilters) > 0){
                    utils.refReplace(resourceFilters, this.model.resourceFilters)
                }

                this.model.resourceFilters = resourceFilters
                this.sanitizeResourceFilters(storage, resourceFilters, actionKey, true)
            } else {
                this.sanitizeResourceFilters(storage, resourceFilters, actionKey, false)
            }

            return resourceFilters
        },

        sanitizeResourceFilters(storage, resourceFilters, actionKey){
            resourceFilters = resourceFilters || {}

            if(actionKey === 'refreshResources'){
                resourceFilters.filters                 = resourceFilters.filters || {}
                resourceFilters.filters.visibleRange    = {...(this.model.visibleRange || {})}
            }
        },

        loadResourcesGranted(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
            if(actionKey === 'refreshResources'){
                return utils.collectionSize((resourceFilters || {}).filters) >= 2
            }

            return true
        },

        updateFilters(filters){
            this.model.resourceFilters = this.model.resourceFilters || {}

            if(!utils.isEqual(this.model.resourceFilters.filters || {}, filters || {})){
                this.model.resourceFilters.filters = {...filters}

                // prevent multiple resource loading operations on init via delay
                this.delayedLastOf('refreshByFilterUpdate', () => this.refresh(), this.config.filterDelay)
            }
        },

        sanitizeResources(){
            this.model.taskData = []
            this.model.loadedStatusIDs = {}

            let statusSymbolIcon, statusSymbolTitle, alt, preStatusSymbol
            utils.forEach(this.resourceData.data || [], (element, key) => {
                const attributes = element.attributes || {}
                const type = attributes.type
                const taskClasses = [type]
                alt = attributes.title

                statusSymbolIcon = 'fi fi-check'
                statusSymbolTitle = ''
                preStatusSymbol = ''
                const statusFlagsSummary = attributes.statusFlagsSummary || {}
                if(statusFlagsSummary.maxSeverity){
                    statusSymbolIcon = `fi fi-severity-${statusFlagsSummary.maxSeverity} severity_${statusFlagsSummary.maxSeverity}`
                }

                for(const statusID in statusFlagsSummary.statusIDs || {}){
                    this.model.loadedStatusIDs[statusID] = true
                }

                if(type === 'capacity'){
                    statusSymbolIcon = ''
                    let employeeNames = attributes.freeEmployeeNames || []
                    const nrOfEmployeeNames = employeeNames.length
                    if(nrOfEmployeeNames > 0){
                        if(nrOfEmployeeNames > 30){
                            employeeNames = employeeNames.splice(0, 30)
                            employeeNames.push(`... und ${nrOfEmployeeNames - 30} weitere`)
                        }
                        alt = [storage.__('scheduler.entities.capacity.freeWorkers')].concat(employeeNames.map(name => `\t${name}`)).join('\n')
                    }
                } else if(type === 'absence'){
                    statusSymbolIcon = ''
                    const elementsByAbsenceTypeByPersonType = {}
                    const titlePartsByType = {}
                    let elements, titlePart
                    for(const entry of Object.values(attributes.entries || [])){
                        elementsByAbsenceTypeByPersonType[entry.absenceType] = elementsByAbsenceTypeByPersonType[entry.absenceType] || {}
                        titlePart = titlePartsByType[entry.absenceType] = titlePartsByType[entry.absenceType] || {}
                        titlePart.nrOfPersons = (titlePart.nrOfPersons || 0) + entry.nrOfEmployees + entry.nrOfContractors

                        for(const personKey in entry.data || {}){
                            for(const absence of entry.data[personKey] || []){
                                if(absence.personType){
                                    elements = elementsByAbsenceTypeByPersonType[entry.absenceType][absence.personType] = elementsByAbsenceTypeByPersonType[entry.absenceType][absence.personType] || []
                                    elements.push(`${absence.name} ${utils.moment(absence.startTS).format('DD.MM.YYYY HH:mm')} - ${utils.moment(absence.endTS).format('DD.MM.YYYY HH:mm')}`)
                                }
                            }
                        }
                    }
                    attributes.title = ''
                    for(const absenceType in titlePartsByType){
                        attributes.title = `${attributes.title}<div class="absence"><i class='fi fi-${absenceType}'></i>${titlePartsByType[absenceType].nrOfPersons || 0}</div>`
                    }

                    for(const absenceType in elementsByAbsenceTypeByPersonType){
                        for(const personType in elementsByAbsenceTypeByPersonType[absenceType]){
                            elementsByAbsenceTypeByPersonType[absenceType][personType] = [storage.__(`scheduler.entities.${type}.${absenceType}.${personType}`)].concat(
                                elementsByAbsenceTypeByPersonType[absenceType][personType].map(element => `\t${element}`)
                            ).join('\n')
                        }
                        if(utils.collectionSize(elementsByAbsenceTypeByPersonType[absenceType]) > 0){
                            elementsByAbsenceTypeByPersonType[absenceType] = Object.values(elementsByAbsenceTypeByPersonType[absenceType]).join('\n\n')
                        }
                    }

                    if(utils.collectionSize(elementsByAbsenceTypeByPersonType) > 0){
                        alt = Object.values(elementsByAbsenceTypeByPersonType).join('\n\n')
                    }
                } else if(type === 'project') {
                    if(attributes.employeeStatusFlagsSummary){
                        const employeeStatusFlagsSummary = this.prepareEmployeeStatusFlagsSummary(attributes.employeeStatusFlagsSummary) || {}
                        const clazz = ['statusSymbol preStatusSymbol employeeStatusFlagsSummary fi fi-user'].concat(employeeStatusFlagsSummary.additionalClasses || []).join(' ')
                        preStatusSymbol = `<i class="${clazz}" title="${employeeStatusFlagsSummary.title}"></i>`
                    }

                    const {
                        maxScore,
                        employeeStatusOutDatedScore,
                        externalEmployeeRevokedScore,
                    } = attributes

                    if(externalEmployeeRevokedScore < maxScore) {
                        taskClasses.push('externalEmployeeRevokedScoreLow')
                    } else if(employeeStatusOutDatedScore < maxScore){
                        taskClasses.push('employeeStatusOutDatedScoreLow')
                    } else {
                        taskClasses.push('employeeStatusOutDatedScoreMaxedOut')
                    }
                }

                const statusSymbolAttributes = [`class="statusSymbol ${statusSymbolIcon}"`]
                if(statusSymbolTitle){
                    statusSymbolAttributes.push(`title="${statusSymbolTitle}"`)
                }

                this.model.taskData.push({
                    title: `<i class="entitySymbol fi fi-${type}"></i><div class="term">${attributes.title || ''}</div>${preStatusSymbol}<i ${statusSymbolAttributes.join(' ')}></i>`,
                    alt,
                    date: attributes.startTS,
                    class: taskClasses.join(' '),
                    dataType: type,
                    dataID: key,
                    showTime: false,
                    attributes,
                })
            })
        },

        prepareEmployeeStatusFlagsSummary(statusFlagsSummary){
            statusFlagsSummary = statusFlagsSummary || {}
            const severities = statusFlagsSummary.severities || {}
            const maxSeverity = statusFlagsSummary.maxSeverity || 'ok'

            // set title
            let title = ''
            const titleParts = []
            for(const severity of ['error', 'warning', 'info']){
                const entityReasonSeverityTypes = (severities[severity] || {}).entityReasonSeverityTypes || []
                if(entityReasonSeverityTypes.length > 0){
                    titleParts.push(`${storage.__(`statusFlags.severity.${severity}`)}:\n${entityReasonSeverityTypes.map(entityReasonSeverityType => ` - ${storage.__(`statusFlags:${entityReasonSeverityType}`)}`).join('\n')}`)
                }
            }
            if(titleParts.length > 0){
                title = titleParts.join('\n\n')
            }

            // set additional classes
            const additionalClasses = [`severity_${maxSeverity}`]

            return {
                title,
                additionalClasses
            }
        },

        async onTaskClicked(taskType, taskID){
            const {dataType} = (this.model.taskData[taskID] || {})
            if(dataType === 'project'){
                const {projectID, projectTermID} = (this.model.taskData[taskID].attributes || {})
                if(projectID && projectTermID){
                    const controller = getComponent($(`.${this.config.projectsControllerComponentClass}`))
                    if(controller){
                        return controller.showEdit('projects', projectID, {
                            attributes: { projectID },
                            primaryKey: 'projectID'
                        })
                            .then(actionContext => {

                                // within the customerTool the whole project is gonna open at once
                                if(this.scope === 'customers'){
                                    return
                                }

                                let controller
                                actionContext.component.find(this.config.projectTermsControllerComponentClass, c => {
                                    const foundProjectID = ((((c.model || {}).parentEntity || {}).entityData || {}).attributes || {}).projectID
                                    if(projectID == foundProjectID){
                                        controller = c
                                        return 'break'
                                    }
                                })

                                if(controller){
                                    return controller.showEdit('projectTerms', projectTermID, {
                                        attributes: { projectTermID },
                                        primaryKey: 'projectTermID'
                                    })
                                }
                            })
                    }
                }
            } else if (dataType === 'absence'){
                const {entries} = (this.model.taskData[taskID].attributes || {})
                const searchTerm = Object.values(entries || {}).map(entry =>
                    Object.values((entry || {}).data).map(person =>
                        Object.values(person)
                            .map(absence => `#${String((absence || {}).absenceID || '').trim()}`)
                            .join(', ')
                    ).join(', ')
                ).join(', ')
                if(searchTerm){
                    // const searchTerm = absenceIDs.map(absenceID => `#${String(absenceID || '').trim()}`).join(', ')
                    const action = await getComponent('mainNav').navToList('absence')
                    // console.log('searchTerm', searchTerm, action)
                    const tabContent = getComponent('mainNav').getActiveTabComponent('tabContent')
                    tabContent.triggerFind('resetFilters', {
                        filters: {
                            searchTerm
                        }
                    })

                }
            }
        },

        onTaskHoverIn(taskType, taskID){
            const {dataType} = (this.model.taskData[taskID] || {})
            if(!this.model.problemSummaryComponent && this.config.problemSummaryComponentClass){
                this.locate(`< templates_core_controller_controller > ${this.config.problemSummaryComponentClass}`, problemSummary => {
                    this.model.problemSummaryComponent = problemSummary
                })
            }

            if(!this.model.problemSummaryComponent) return;

            if(dataType === 'project'){
                const {problemSummary} = ((this.model.taskData[taskID].attributes || {}).statusFlagsSummary || {})
                this.model.problemSummaryComponent.update(problemSummary)
            }
        },

        onTaskHoverOut(taskType, taskID){
            if(!this.model.problemSummaryComponent) return;
            this.model.problemSummaryComponent.update()
        },

        /**
         * is at least of the given statusIDs loaded
         * @param statusIDs     object - {<statusID>: true, ...}
         * @returns {boolean}
         */
        isAtLeastOneStatusIDLoaded(statusIDs){
            for(const statusID in statusIDs || {}){
                if((this.model.loadedStatusIDs || {})[statusID]){
                    return true
                }
            }

            return false
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers    = this.config.heartbeatRefreshOn || {}
            const key           = message.heartbeatKey
            const myEmployeeID  = (((((storage || {}).user || {}).data || {}).userTableAssociates || {}).employee || {}).employeeID

            if(refreshers[key] && (
                (
                    key !== 'resourceChanged.bo_status' &&
                    key !== 'resourceChanged.bo_projectTermJobStatus' &&
                    key !== 'resourceChanged.bo_employees'
                ) ||
                (key === 'resourceChanged.bo_status' && this.isAtLeastOneStatusIDLoaded(message.data.statusIDs)) ||
                (key === 'resourceChanged.bo_projectTermJobStatus' && myEmployeeID && myEmployeeID == message.data.employeeID) ||
                (key === 'resourceChanged.bo_employees' && myEmployeeID && myEmployeeID == (message.data.primaryKey || message.data.employeeID))
            )){
                this.delayedLastOf('refreshByHeartbeat', () => this.refresh(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes }), 50)
            }
        },
    },
}